import React, { useCallback, useRef, useState } from 'react';
import ConfirmDialog from '../components/ConfirmDialog';

export default function useConfirm() {
  const [options, setOptions] = useState(null);
  const [open, setOpen] = useState(false);
  const resolverRef = useRef(null);

  const confirm = useCallback((opts = {}) => new Promise((resolve) => {
    resolverRef.current = resolve;
    setOptions(opts);
    setOpen(true);
  }), []);

  const close = (result) => {
    if (resolverRef.current) {
      resolverRef.current(result);
      resolverRef.current = null;
    }
    setOpen(false);
  };

  const dialog = (
    <ConfirmDialog
      open={open}
      title={options?.title}
      message={options?.message}
      confirmLabel={options?.confirmLabel}
      cancelLabel={options?.cancelLabel}
      destructive={options?.destructive}
      onConfirm={() => close(true)}
      onCancel={() => close(false)}
      onExited={() => setOptions(null)}
    />
  );

  return { confirm, confirmDialog: dialog };
}
